(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initQuiz(root) {
    if (root.dataset.mbInit === 'true') return;
    root.dataset.mbInit = 'true';

    var transitionMs = parseInt(root.dataset.transitionMs || '3000', 10);
    if (prefersReduced) transitionMs = Math.min(transitionMs, 600);

    var stages = Array.prototype.slice.call(root.querySelectorAll('.mb-quiz__stage'));
    var introStage = root.querySelector('[data-stage="intro"]');
    var questionStages = stages.filter(function (s) { return s.dataset.stage === 'question'; });
    var transitionStage = root.querySelector('[data-stage="transition"]');
    var resultStages = stages.filter(function (s) { return s.dataset.stage === 'result'; });
    var total = questionStages.length;

    // Total de la progression (barre supérieure, niveau section)
    var totalEl = root.querySelector('[data-progress-total]');
    if (totalEl) totalEl.textContent = total;

    var state = { step: 0, answers: {}, audience: 'self', timer: null };
    var mqMobile = window.matchMedia('(max-width: 749px)');

    // Choisit le média desktop ou mobile d'une réponse (repli sur desktop si mobile vide)
    function answerMedia(el) {
      var m = mqMobile.matches;
      var img = m ? (el.getAttribute('data-bg-img-m') || el.getAttribute('data-bg-img')) : el.getAttribute('data-bg-img');
      var vid = m ? (el.getAttribute('data-bg-video-m') || el.getAttribute('data-bg-video')) : el.getAttribute('data-bg-video');
      return { img: img, vid: vid };
    }

    // Précharge dès le chargement TOUS les médias du quiz :
    //  - images des réponses/niveaux (injectées en JS au clic)
    //  - fonds des écrans intro / transition / questions (rendus côté serveur)
    // Les écrans spéciaux étant masqués au départ, leurs images "lazy" ne se
    // chargeraient pas tant qu'ils ne sont pas affichés → on force le chargement.
    function preloadMedia() {
      var seen = {};
      function add(u) { if (u && !seen[u]) { seen[u] = 1; var im = new Image(); im.src = u; } }

      // Médias des réponses / niveaux (attributs data-*)
      root.querySelectorAll('.mb-quiz__answer, .mb-quiz__dot').forEach(function (el) {
        add(el.getAttribute('data-bg-img'));
        add(el.getAttribute('data-bg-img-m'));
      });

      // Fonds des écrans (intro, transition, questions) : on force le chargement
      // immédiat même si l'écran est masqué, puis on met l'image en cache.
      root.querySelectorAll('.mb-quiz__bg img').forEach(function (img) {
        try { img.loading = 'eager'; img.removeAttribute('loading'); } catch (e) {}
        add(img.getAttribute('src'));
      });

      // Vidéos de fond : on garantit l'autoplay (muet) sans réinitialiser la lecture.
      // (NE PAS appeler v.load() : cela remet la vidéo à zéro et casse l'autoplay.)
      root.querySelectorAll('.mb-quiz__bg video').forEach(playBgVideo);
    }

    // Force la lecture en autoplay (muet) d'une vidéo de fond
    function playBgVideo(v) {
      if (!v) return;
      try {
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.preload = 'auto';
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } catch (e) {}
    }
    preloadMedia();

    /* ---- Texte dynamique « pour moi » / « pour offrir » ---- */
    function applyAudience(stage) {
      var aud = state.audience || 'self';
      var q = stage.querySelector('.mb-quiz__question');
      if (q) {
        var qs = q.getAttribute('data-self');
        var qg = q.getAttribute('data-gift');
        if (qs) q.textContent = (aud === 'gift' && qg) ? qg : qs;
      }
      stage.querySelectorAll('.mb-quiz__answer').forEach(function (a) {
        var te = a.querySelector('.mb-quiz__answer-text');
        if (!te) return;
        var s = a.getAttribute('data-text-self');
        var g = a.getAttribute('data-text-gift');
        if (s) te.textContent = (aud === 'gift' && g) ? g : s;
      });
      stage.querySelectorAll('.mb-quiz__desc[data-aud]').forEach(function (d) {
        d.style.display = (d.getAttribute('data-aud') === aud) ? '' : 'none';
      });
    }

    function clearTimer() {
      if (state.timer) { clearTimeout(state.timer); state.timer = null; }
    }

    function showStage(target) {
      stages.forEach(function (s) { s.classList.toggle('is-active', s === target); });
      // Relance la vidéo de fond de l'écran qui apparaît (intro, loading, question, résultat)
      if (target) playBgVideo(target.querySelector('.mb-quiz__bg video'));
    }

    function setQuestionMode(on) {
      root.classList.toggle('is-question', !!on);
    }

    /* ---- Fonds qui changent selon la réponse (crossfade sur 2 couches) ---- */
    function bgLayers(stage) {
      return [
        stage.querySelector('[data-answer-bg-0]'),
        stage.querySelector('[data-answer-bg-1]')
      ];
    }

    function clearAnswerBg(stage) {
      bgLayers(stage).forEach(function (l) {
        if (l) {
          l.classList.remove('is-shown');
          l.innerHTML = '';
          l.style.backgroundImage = '';
        }
      });
      stage._mbBg = -1;
    }

    // Double-buffer anti-flicker : la nouvelle image charge en arrière-plan ;
    // une fois PRÊTE, elle apparaît en fondu PAR-DESSUS l'ancienne (qui reste
    // visible dessous). Le fond de la question ne réapparaît jamais — aucun flash.
    function applyAnswerBg(stage, imgUrl, videoUrl) {
      var layers = bgLayers(stage);
      if (!layers[0] || !layers[1]) return;
      // Règle : si AUCUN média pour cette réponse → on GARDE le média actuellement
      // affiché (pas de retour au fond de la question). La remise à zéro explicite se
      // fait ailleurs (changement de question / recommencer) via clearAnswerBg().
      if (!imgUrl && !videoUrl) { return; }

      var active = (typeof stage._mbBg === 'number') ? stage._mbBg : -1;
      var next = active === 0 ? 1 : 0;
      var layer = layers[next];

      // Jeton : si on reclique vite, les chargements obsolètes sont ignorés.
      stage._mbReq = (stage._mbReq || 0) + 1;
      var req = stage._mbReq;

      function reveal() {
        if (req !== stage._mbReq) return;
        layer.style.zIndex = '2';
        layer.classList.add('is-shown');
        if (active === 0 || active === 1) {
          var old = layers[active];
          old.style.zIndex = '1';
          // On garde l'ancienne couche visible jusqu'à la fin du fondu de la nouvelle.
          clearTimeout(stage._mbBgTimer);
          stage._mbBgTimer = setTimeout(function () {
            if (req === stage._mbReq) old.classList.remove('is-shown');
          }, 850);
        }
        stage._mbBg = next;
      }

      if (videoUrl) {
        layer.style.backgroundImage = '';
        layer.innerHTML =
          '<video autoplay muted loop playsinline preload="auto"><source src="' +
          videoUrl + '"></video>';
        reveal();
        return;
      }

      var done = false;
      function commit() {
        if (done || req !== stage._mbReq) return;
        done = true;
        layer.innerHTML = '';
        layer.style.backgroundImage = 'url("' + imgUrl + '")';
        reveal();
      }
      var pre = new Image();
      pre.onload = commit;
      pre.onerror = commit;
      pre.src = imgUrl;
      if (pre.complete && pre.naturalWidth) commit();
    }

    function updateProgress(index) {
      var fill = root.querySelector('[data-progress-fill]');
      var current = root.querySelector('[data-progress-current]');
      var ratio = total ? (index + 1) / total : 0;
      if (fill) fill.style.width = Math.max(0, Math.min(100, ratio * 100)) + '%';
      if (current) current.textContent = index + 1;
    }

    function confirmBtn(stage) { return stage.querySelector('[data-action="confirm"]'); }

    function goToStep(index) {
      if (index < 0 || index >= questionStages.length) return;
      state.step = index;
      var stage = questionStages[index];
      showStage(stage);
      setQuestionMode(true);
      updateProgress(index);
      applyAudience(stage);
      // Le bouton « retour » est toujours visible ; sur la 1re question il ramène à l'intro
      var backBtn = stage.querySelector('[data-action="back"]');
      if (backBtn) backBtn.style.display = '';
      restoreSelection(stage, index);
      if (!prefersReduced) root.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    /* ---- Curseur à points ---- */
    function sliderDots(stage) {
      return Array.prototype.slice.call(stage.querySelectorAll('.mb-quiz__dot'));
    }

    function applySliderStop(stage, stopVal) {
      var dots = sliderDots(stage);
      var activeDot = null;
      dots.forEach(function (dot) {
        var v = parseInt(dot.dataset.stop, 10);
        dot.classList.toggle('is-active', v === stopVal);
        dot.classList.toggle('is-filled', v <= stopVal);
        if (v === stopVal) activeDot = dot;
      });
      var fill = stage.querySelector('[data-slider-fill]');
      if (fill && activeDot) fill.style.width = activeDot.offsetLeft + 'px';
      stage._mbStop = stopVal;
    }

    function dotForStop(stage, stopVal) {
      return stage.querySelector('.mb-quiz__dot[data-stop="' + stopVal + '"]');
    }

    function restoreSelection(stage, index) {
      var saved = state.answers[index];
      var btn = confirmBtn(stage);
      var slider = stage.querySelector('[data-slider]');

      if (slider) {
        var dots = sliderDots(stage);
        var mid = Math.ceil(dots.length / 2) || 1;
        var stopVal = saved ? saved.stop : mid;
        applySliderStop(stage, stopVal);
        var dot = dotForStop(stage, stopVal);
        if (dot) { var dm = answerMedia(dot); applyAnswerBg(stage, dm.img, dm.vid); }
        if (btn) btn.disabled = false;
        return;
      }

      var answers = stage.querySelectorAll('.mb-quiz__answer');
      var selEl = null;
      answers.forEach(function (a) {
        var isSel = saved && a.dataset.profile === saved.profile && a.dataset.idx === String(saved.idx);
        a.classList.toggle('is-selected', !!isSel);
        a.setAttribute('aria-pressed', isSel ? 'true' : 'false');
        if (isSel) selEl = a;
      });

      if (selEl) {
        var m = answerMedia(selEl);
        applyAnswerBg(stage, m.img, m.vid);
      } else {
        clearAnswerBg(stage);
      }
      if (btn) btn.disabled = !selEl;
    }

    // ---- Intro ----
    var startBtn = introStage ? introStage.querySelector('[data-action="start"]') : null;
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        clearTimer();
        if (questionStages.length) goToStep(0);
        else finish();
      });
    }

    // ---- Questions ----
    questionStages.forEach(function (stage, index) {
      // Réponses (choix)
      stage.querySelectorAll('.mb-quiz__answer').forEach(function (answer, ai) {
        answer.dataset.idx = ai;
        answer.addEventListener('click', function () {
          stage.querySelectorAll('.mb-quiz__answer').forEach(function (a) {
            a.classList.remove('is-selected');
            a.setAttribute('aria-pressed', 'false');
          });
          answer.classList.add('is-selected');
          answer.setAttribute('aria-pressed', 'true');

          // Définit l'audience (pour moi / pour offrir) si la réponse le précise
          var aud = answer.getAttribute('data-audience');
          if (aud && aud !== 'none' && aud !== '') state.audience = aud;

          var media = answerMedia(answer);
          applyAnswerBg(stage, media.img, media.vid);

          state.answers[index] = {
            profile: answer.dataset.profile || 'none',
            idx: ai
          };
          var btn = confirmBtn(stage);
          if (btn) btn.disabled = false;
        });
      });

      // Curseur (points = sous-blocs niveau)
      var slider = stage.querySelector('[data-slider]');
      if (slider) {
        sliderDots(stage).forEach(function (dot, di) {
          dot.dataset.stop = di + 1;
        });
        var setStop = function (stopVal) {
          applySliderStop(stage, stopVal);
          var dot = dotForStop(stage, stopVal);
          var profile = dot ? (dot.dataset.profile || 'none') : 'none';
          if (dot) { var dm = answerMedia(dot); applyAnswerBg(stage, dm.img, dm.vid); }
          else applyAnswerBg(stage, '', '');
          state.answers[index] = { profile: profile, stop: stopVal };
          var btn = confirmBtn(stage);
          if (btn) btn.disabled = false;
        };
        sliderDots(stage).forEach(function (dot) {
          dot.addEventListener('click', function () { setStop(parseInt(dot.dataset.stop, 10)); });
        });
      }

      var cBtn = confirmBtn(stage);
      if (cBtn) {
        cBtn.addEventListener('click', function () {
          if (cBtn.disabled) return;
          if (index >= total - 1) finish();
          else goToStep(index + 1);
        });
      }
      var backBtn = stage.querySelector('[data-action="back"]');
      if (backBtn) {
        backBtn.addEventListener('click', function () {
          if (index === 0) {
            if (introStage) {
              showStage(introStage);
              if (!prefersReduced) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          } else {
            goToStep(index - 1);
          }
        });
      }
    });

    // Recalcule la position du remplissage du curseur après redimensionnement
    window.addEventListener('resize', function () {
      var stage = questionStages[state.step];
      if (!stage || !stage.classList.contains('is-active')) return;
      if (typeof stage._mbStop === 'number') {
        applySliderStop(stage, stage._mbStop);
        var dot = dotForStop(stage, stage._mbStop);
        if (dot) { var dm = answerMedia(dot); applyAnswerBg(stage, dm.img, dm.vid); }
      }
      var sel = stage.querySelector('.mb-quiz__answer.is-selected');
      if (sel) { var m = answerMedia(sel); applyAnswerBg(stage, m.img, m.vid); }
    });

    // ---- Calcul du résultat (priorité à la question décisive) ----
    function computeWinner() {
      var scores = {};
      var deciderProfile = null;

      questionStages.forEach(function (stage, index) {
        var ans = state.answers[index];
        if (!ans || !ans.profile || ans.profile === 'none') return;
        scores[ans.profile] = (scores[ans.profile] || 0) + 1;
        if (stage.dataset.decider === 'true') deciderProfile = ans.profile;
      });

      if (deciderProfile) return deciderProfile;

      var best = null;
      Object.keys(scores).forEach(function (k) {
        if (best === null || scores[k] > scores[best]) best = k;
      });
      return best;
    }

    function showResult(profile) {
      var target = null;
      if (profile) {
        target = resultStages.filter(function (r) { return r.dataset.profile === profile; })[0];
      }
      if (!target && resultStages.length) target = resultStages[0];
      setQuestionMode(false);
      if (target) {
        showStage(target);
        if (!prefersReduced) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function finish() {
      clearTimer();
      setQuestionMode(false);
      if (transitionStage) {
        showStage(transitionStage);
        var winner = computeWinner();
        state.timer = setTimeout(function () { showResult(winner); }, transitionMs);
      } else {
        showResult(computeWinner());
      }
    }

    // ---- Recommencer ----
    root.querySelectorAll('[data-action="restart"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        clearTimer();
        state.answers = {};
        state.step = 0;
        state.audience = 'self';
        setQuestionMode(false);
        questionStages.forEach(function (stage) {
          stage.querySelectorAll('.mb-quiz__answer').forEach(function (a) {
            a.classList.remove('is-selected');
            a.setAttribute('aria-pressed', 'false');
          });
          clearAnswerBg(stage);
          var b = confirmBtn(stage);
          if (b) b.disabled = true;
        });
        if (introStage) showStage(introStage);
        if (!prefersReduced) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // ---- Pop-up « Notes olfactives » (résultat) ----
    function closeNotes() {
      root.querySelectorAll('[data-notes-modal].is-open').forEach(function (m) { m.classList.remove('is-open'); });
    }
    root.querySelectorAll('[data-notes-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var stage = btn.closest('.mb-quiz__stage');
        var modal = stage && stage.querySelector('[data-notes-modal]');
        if (modal) modal.classList.add('is-open');
      });
    });
    root.querySelectorAll('[data-notes-close]').forEach(function (btn) {
      btn.addEventListener('click', closeNotes);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeNotes();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mb-quiz]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mb-quiz]');
    if (root) { root.dataset.mbInit = 'false'; initQuiz(root); }
  });
})();
